import { render, staticRenderFns } from "./RobotDetails.vue?vue&type=template&id=aee2b8fa&scoped=true"
import script from "./RobotDetails.vue?vue&type=script&lang=js"
export * from "./RobotDetails.vue?vue&type=script&lang=js"
import style0 from "./RobotDetails.vue?vue&type=style&index=0&id=aee2b8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee2b8fa",
  null
  
)

export default component.exports